import { createSlice } from "@reduxjs/toolkit";

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    fetchCategoryStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    fetchCategorySuccess: (state, action) => {
      state.isFetching = false;
      state.categories = action.payload;
    },
    fetchCategoryFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  fetchCategoryStart,
  fetchCategorySuccess,
  fetchCategoryFailure,
} = categorySlice.actions;

export default categorySlice.reducer;
